export const wholesaleOrders = {
  WholesaleOrders: "Wholesale orders",
  OrderNumber: "Order #{{slug}}",
  Ordered: "Ordered",
  PlaceOrderAgain: "Place order again",
  OrderPlaced: "Order placed",
  OrderConfirmed: "Order confirmed",
  OrderConfirmedMessage:
    "Your payment of <strong>{{payment}}</strong> has been processed successfully. A confirmation email has been sent to your inbox.",
  OrderPlacedBy: "Order placed by",
  ByMe: "By me",
  ByAnyone: "By anyone",
  ByAnyoneOnFullscript: "By anyone on Fullscript",
  ByName: "By {{name}}",
  BackToOrders: "Back to orders",
  AtNaturalPartners: "At Natural Partners",
  OnFullscript: "on Fullscript",
  ShippingAddress: "Shipping address",
  BillingAddress: "Billing address",
  Payment: "Payment",
  YouHaventPlacedOrdersYet: "You haven't placed any wholesale orders yet.",
  NoOrdersDuringThisTime: "Looks like you didn't place any orders during this time",
  ShipmentUnavailable: "Shipment status unavailable",
  ImportedFromOutsideFullscript: "Order imported from outside Fullscript",
  TrackOrder: "Track order",
  Track: "Track",
  InventoryLimitReached: "Inventory limit reached",

  Newest: "Newest",
  Oldest: "Oldest",
  MostRecent: "Most recent",
  LeastExpensive: "Price: Low - High",
  MostExpensive: "Price: High - Low",
  AtoZ: "Product name: A-Z",
  ZtoA: "Product name: Z-A",
  LastOrdered: "Last ordered",

  OrderedOn: "Ordered on",
  ShippedTo: "Shipped to",
  OutForShipment: "Out for shipment",
  ShippingDetails: "Shipping details",
  EstimatedDelivery: "Est. delivery: ",
  ariaLinkToAccount: "Link to Account {{orderNumber}}",

  ariaCreditCard: "Paid with {{ccType}}",
  ariaCreditCardDetails: "Cardholder name and last four digits of credit card",
  DownloadInvoice: "Download invoice",
  Invoice: "Invoice",
  AsOfDate: "As of {{date}}",
  Processing: "Processing",
  Canceled: "Canceled",

  itemsSelected: "{{count}} item selected",
  itemsSelected_plural: "{{count}} items selected",
  selectItems: "Select {{count}} item",
  selectItems_plural: "Select {{count}} items",

  AllShipments: "All shipments",
  AllInventory: "All Inventory",
  ShipmentNumber: "Shipment {{index}}",
  TrackingUnavailable:
    "Tracking information currently unavailable. If you need help, please contact <2>Help & Support</2>.",
  MoreShipmentsToCome: "We'll have more shipments to share as we continue to fulfill your order",

  Total: "Total: <blur>{{total}}</blur>",
  ShippedShipments: "<0>{{- numberShipped}}</0> Shipped",
  Shipped: "{{- numberShipped}} Shipped",
  Units: "{{quantity}} Unit",
  Units_plural: "{{quantity}} Units",
  PerUnit: " / Unit",
  Shipping: "Shipping",
  Savings: "Savings",
  Taxes: "Taxes",
  SubTotal: "Subtotal",
  ProductSubtotal: "Product subtotal",
  LabKitSubtotal: "Lab kit subtotal",
  TotalUsd: "Total (USD)",
  TotalCad: "Total (CAD)",
  Charged: "Charged",
  Free: "Free",
  FREE: "FREE",
  InfoIcon: "i",
  TotalAmountTooltip:
    "This is the total amount that we will charge to your selected payment method",

  ariaAllLineItemCheckbox: "select/deselect all line items",
  ariaLineItemCheckbox: "select/deselect {{ name }}",

  AvatarFor: "Avatar for {{ name }}",

  CyberMondaySale: "Cyber Monday sale",
  OrderPlacedDuringCyberMonday:
    "This order was placed during our Cyber Monday sale. Note that prices will be updated when purchasing products from this order again",
  OrderedThroughCyberMonday: "Ordered through cyber monday sale",
  ImportedFromNP: "Order imported from Natural Partners",
  NpOrderListsDisclaimer: "Some items may not be shown if they are not available on Fullscript",
  LineItemNotInFs:
    "We don't carry this product but we might have something similar in <1>our catalog</1>.",
  OrderHistoryPriceWarning: "The price indicated might not reflect the price paid on the order",
  IncorrectOrderLink: "The specified order does not exist, try a different link",
} as const;
